// extracted by mini-css-extract-plugin
export var change = "_4b-1";
export var changeList = "_4b-0";
export var changePath = "_4b-2";
export var diffArrow = "_4b-5";
export var diffRow = "_4b-3";
export var diffValue = "_4b-4";
export var error = "_4b-8";
export var notice = "_4b-9";
export var result = "_4b-6";
export var success = "_4b-7";